import UpdateReceivedFactor from "./UpdateReceivedFactor";

export default UpdateReceivedFactor;
